import { render, staticRenderFns } from "./AttributeDependenciesDialog.vue?vue&type=template&id=c314c63e"
import script from "./AttributeDependenciesDialog.vue?vue&type=script&lang=ts"
export * from "./AttributeDependenciesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports